export enum DataLevel {
  USER = 'USER',
  ORDER = 'ORDER',
  RESERVATION = 'RESERVATION'
}
